module.exports = __webpack_public_path__ + "img/yichi.6869fab8.jpg";